import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import config from '../../config';
import SectionTitle from '../SectionTitle';
import TunerApps from './TunerApps';
import TunerFeatureScreens from './TunerFeatureScreens';
import TunerHeadstock from './TunerHeadstock';

const messages = defineMessages({
  toolsRef: {
    id: 'tuner.toolsRef',
    defaultMessage: 'Tools and Reference',
  },
});

const Tuner: React.FC = () => (
  <div className="tuner" data-id="tuner">
    <h2 className="pa0 ma0 futura-heavy mv3 tc tl-ns f4 f2-ns" data-id="tuner-title">
      <FormattedMessage {...messages.toolsRef} />
    </h2>
    <div className="pb3">
      <SectionTitle title="Online Guitar Tuner" titleStyles="tc tl-ns w-100" />
    </div>
    <TunerHeadstock list={config.tuner.headstocks} />
    <TunerApps />
    <TunerFeatureScreens list={config.tuner.featureScreens} />
  </div>
);

export default Tuner;
